import React, { useEffect, useState } from "react";
import { Label, UncontrolledTooltip } from "reactstrap";
import { Capacitor } from "@capacitor/core";

// interface
import { BasicDetailsTypes } from "../../../data/settings";
import { Utils } from "helpers/utils";
import { performAppUpdateCheck } from "api/profile";
import { useRedux } from "hooks";
import { setAppUpdateInfo } from "../../../redux/actions";
import PlatformVersionInfo from "components/PlatformVersionInfo";

interface UserCoverImageProps {
  basicDetails: BasicDetailsTypes;
}
const UserCoverImage = ({ basicDetails }: UserCoverImageProps) => {
  const { useAppSelector, dispatch } = useRedux();
  const userType = useAppSelector((state: any) => state.Profile2.userType);
  const [image, setImage] = useState<string>(
    basicDetails && Utils.FixResourceUrlForNative(basicDetails.coverImage)
  );
  useEffect(() => {
    if (basicDetails && basicDetails.coverImage) {
      setImage(Utils.FixResourceUrlForNative(basicDetails.coverImage));
    }
  }, [basicDetails]);
  const [checkingUpdate, setCheckingUpdate] = useState(false);
  const handleCheckUpdate = async () => {
    if (checkingUpdate) return;
    setCheckingUpdate(true);
    try {
      const result = await performAppUpdateCheck(userType);
      dispatch(setAppUpdateInfo(result));
      Utils.ShowAppUpdateResult(result);
    } catch (e) {
      Utils.HandleException(e, true);
    } finally {
      setCheckingUpdate(false);
    }
  };

  const handleClearAppUpdateInfo = () => {
    Utils.ClearAppUpdateInfo();
    dispatch(setAppUpdateInfo(null));
  };

  const onChangeProfileCover = (e: any) => {
    const files = [...e.target.files];
    if (files[0]) {
      const src = URL.createObjectURL(files[0]);
      setImage(src);
    }
  };
  return (
    <div className="user-profile-img">
      <img
        src={image}
        className="profile-img profile-foreground-img"
        style={{ height: "80px" }}
        alt=""
      />
      <div className="overlay-content">
        <div>
          <div className="user-chat-nav p-3">
            <div className="d-flex w-100 align-items-center">
              <div className="flex-grow-1">
                <h5 className="text-white mb-0">
                  Settings (<PlatformVersionInfo />)
                  {Capacitor.isNativePlatform() && (
                    <span
                      className="ms-1"
                      style={{ cursor: checkingUpdate ? "default" : "pointer", opacity: checkingUpdate ? 0.5 : 1 }}
                      onClick={handleCheckUpdate}
                      title="ตรวจสอบอัปเดต"
                    >
                      🔄
                    </span>
                  )}
                </h5>
                {/* {Capacitor.isNativePlatform() && (
                  <div
                    className="text-white-50 small"
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={handleClearAppUpdateInfo}
                  >
                    [debug] clear appUpdateInfo
                  </div>
                )} */}
              </div>
              <div className="flex-shrink-0" style={{display:"none"}}>
                <div
                  className="avatar-xs p-0 rounded-circle profile-photo-edit"
                  id="change-cover"
                >
                  <input
                    id="profile-foreground-img-file-input"
                    type="file"
                    accept="image/png, image/jpeg"
                    className="profile-foreground-img-file-input"
                    onChange={e => onChangeProfileCover(e)}
                  />
                  <Label
                    htmlFor="profile-foreground-img-file-input"
                    className="profile-photo-edit avatar-xs"
                  >
                    <span className="avatar-title rounded-circle bg-light text-body">
                      <i className="bx bxs-pencil"></i>
                    </span>
                  </Label>
                </div>
                {/* <UncontrolledTooltip target="change-cover" placement="bottom">
                  Change Background
                </UncontrolledTooltip> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCoverImage;
